import { mdiClipboardListOutline } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/shared/logic/administration"
import type { OrgaViewFrameContext } from "../../../../context"
import { canViewOrganizationSettings } from "../../../../_shared/_logic/access"
import type { ContextSessionResponse } from "@kontextwerk/control-web-client"
import type { ContextProductPage } from "@kontextwerk/control-web-frame/shared/logic/context-workspace"
import { allowsKehrblattCapability } from "../../../../../_shared/_logic/context-capabilities"

export const contextOrderTypesPage = (
  session: ContextSessionResponse | null,
  organizationId: string,
) => {
  if (
    session?.context.kind !== "organization" ||
    session.context.organization_id !== organizationId ||
    !allowsKehrblattCapability(session, "core.org_settings", "view")
  )
    return null

  return {
    id: "order-types",
    label: "Auftragstypen",
    href: `/organizations/${organizationId}/administration/order-types`,
    icon: mdiClipboardListOutline,
    placement: "footer",
    admission: {
      kind: "organization",
      organizationId,
      requirements: {
        operation: "kehrblatt.order_types.list",
        all_of: [{ key: "core.org_settings", level: "view", scope: null }],
      },
    },
    canManage: allowsKehrblattCapability(session, "core.org_settings", "manage"),
  } satisfies ContextProductPage & { canManage: boolean }
}

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "order-types",
  title: "Auftragstypen",
  tooltip:
    "Auftragsarten mit interner und öffentlicher Bezeichnung, Beschreibung und üblicher Dauer anlegen und bearbeiten.",
  icon: mdiClipboardListOutline,
  routeSegment: "order-types",
  getPages: (context) =>
    canViewOrganizationSettings(context)
      ? [
          {
            id: "order-types",
            title: "Auftragstypen",
            path: "",
            testId: "controlAdmin.organizationView.tab.orderTypes",
          },
        ]
      : [],
}
